import { StaffRole } from "./staff";

const IMPRESSION_FILES: Record<string, string> = {
  avd: "andy.m4a",
  psromero: "paula.m4a",
  cbartin: "cece.m4a",
  jhall44: "jasper.m4a",
  jgrandch: "jacob.m4a",
};

export function hasImpression(role: StaffRole, cslogin?: string): boolean {
  if (role !== "Professor" && role !== "Head TA") {
    return false;
  }
  return !cslogin || Boolean(IMPRESSION_FILES[cslogin]);
}

export function impressionSrc(cslogin: string): string {
  const file = IMPRESSION_FILES[cslogin];
  return `${process.env.PUBLIC_URL}/staff/impressions/${file ?? `${cslogin}.m4a`}`;
}
